module.exports = __webpack_public_path__ + "about-us.82aff32cbf5fc0831bb6.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/backgrounds/about-us.jpg
// module id = ../../../../../src/assets/images/backgrounds/about-us.jpg
// module chunks = styles